export const currencies = [
  { Name: "AED", Code: "ae", FullName: "UAE Dirham" },
  { Name: "ARS", Code: "ar", FullName: "Argentine Peso" },
  { Name: "AUD", Code: "au", FullName: "Australian Dollar" },
  { Name: "BHD", Code: "bh", FullName: "Bahraini Dinar" },
  { Name: "BGN", Code: "bg", FullName: "Bulgarian Lev" },
  { Name: "BRL", Code: "br", FullName: "Brazilian Real" },
  { Name: "CAD", Code: "ca", FullName: "Canadian Dollar" },
  { Name: "CHF", Code: "ch", FullName: "Swiss Franc" },
  { Name: "CNY", Code: "cn", FullName: "Chinese Yuan" },
  { Name: "CZK", Code: "cz", FullName: "Czech Koruna" },
  { Name: "DKK", Code: "dk", FullName: "Danish Krone" },
  { Name: "EGP", Code: "eg", FullName: "Egyptian Pound" },
  { Name: "EUR", Code: "eu", FullName: "Euro" },
  { Name: "GBP", Code: "gb", FullName: "Pound Sterling" },
  { Name: "HKD", Code: "hk", FullName: "Hong Kong Dollar" },
  { Name: "ILS", Code: "il", FullName: "Israeli New Shekel" },
  { Name: "INR", Code: "in", FullName: "Indian Rupee" },
  { Name: "JPY", Code: "jp", FullName: "Japanese Yen" },
  { Name: "KRW", Code: "kr", FullName: "South Korean Won" },
  { Name: "MXN", Code: "mx", FullName: "Mexican Peso" },
  { Name: "MYR", Code: "my", FullName: "Malaysian Ringgit" },
  { Name: "NOK", Code: "no", FullName: "Norwegian Krone" },
  { Name: "NZD", Code: "nz", FullName: "New Zealand Dollar" },
  { Name: "PLN", Code: "pl", FullName: "Polish Zloty" },
  { Name: "QAR", Code: "qa", FullName: "Qatari Rial" },
  { Name: "RON", Code: "ro", FullName: "Romanian Leu" },
  { Name: "RUB", Code: "ru", FullName: "Russian Ruble" },
  { Name: "SAR", Code: "sa", FullName: "Saudi Riyal" },
  { Name: "SEK", Code: "se", FullName: "Swedish Krona" },
  { Name: "SGD", Code: "sg", FullName: "Singapore Dollar" },
  { Name: "TRY", Code: "tr", FullName: "Turkish Lira" },
  { Name: "THB", Code: "th", FullName: "Thai Baht" },
  { Name: "UAH", Code: "ua", FullName: "Ukrainian Hryvnia" },
  { Name: "USD", Code: "us", FullName: "US Dollar" },
  { Name: "VND", Code: "vn", FullName: "Vietnamese Dong" },
  { Name: "ZAR", Code: "za", FullName: "South African Rand" },
];

export function getCurrency(currencyName: string): {
  Name: string;
  Code: string;
  FullName: string;
} {
  const currency = currencies.find(
    (currency) => currency.Name.toLowerCase() === currencyName.toLowerCase()
  );
  return currency !== undefined
    ? currency
    : { Name: "EUR", Code: "eu", FullName: "Euro" };
}
